import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function WhyItDidntWork() {
  const reasons = ['Intentaste cambiar el "afuera" sin entender que la realidad es solo el colapso de tu observación interna.', 'Buscaste sanación en el pasado, sin saber que el tiempo es un espiral y que todas tus versiones ocurren en simultáneo.', 'Trataste de controlar tus emociones, cuando la clave no es el control, sino el movimiento inteligente a través de ellas.', 'Pediste conexión divina afuera, olvidando que eres una partícula de Dios envasada en un cuerpo.', 'Luchaste contra la enfermedad sin leer el marcador que tu cuerpo te estaba gritando.'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative" data-id="element-200">
      <div className="max-w-5xl mx-auto" data-id="element-201">
        <FadeIn data-id="element-202">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16 text-white" data-id="element-203">
            Por qué lo que intentaste{' '}
            <span className="text-gold-400 italic" data-id="element-204">no funcionó</span>
          </h2>
        </FadeIn>

        <div className="grid gap-6 max-w-3xl mx-auto" data-id="element-205">
          {reasons.map((reason, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-206">
              <div className="flex items-start gap-4 p-6 rounded-lg bg-navy-900/50 border border-white/5 hover:border-gold-500/20 transition-colors group" data-id="element-207">
                <div className="flex-shrink-0 mt-1" data-id="element-208">
                  {/* Custom diamond icon */}
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-gold-500 group-hover:text-gold-400 transition-colors" data-id="element-209">
                    <path d="M12 2L22 12L12 22L2 12L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-210" />
                    <circle cx="12" cy="12" r="3" fill="currentColor" data-id="element-211" />
                  </svg>
                </div>
                <p className="text-gray-300 text-lg leading-relaxed" data-id="element-212">
                  {reason}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}